import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Card, Form, Spin } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import DetailsForm from "./components/detailsTabs/DetailsForm";
import CurrencyForm from "./components/detailsTabs/CurrencyForm";
import TermsForm from "./components/detailsTabs/TermsForm";
import SettingsForm from "./components/detailsTabs/SettingsForm";
import ChargesForm from "./components/detailsTabs/ChargesForm";
import AccountingForm from "./components/detailsTabs/AccountingForm";
import tabList from "./components/tabList.json";
import InterestChartRateForm from "./components/detailsTabs/InterestChartRateForm";

const ViewPRD0400 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [activeTabKey, setActiveTabKey] = useState("details");
  const [redeDetail, setRedeDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById(state);
  }, []);
  console.log(redeDetail, "redeDetail");

  useEffect(() => {
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    if (redeDetail?.active) {
      dispatch({
        type: cnt.RIGHT_REJECT_BTN,
      });
    } else {
      dispatch({
        type: cnt.RIGHT_APPROVE_BTN,
      });
    }
  }, [redeDetail]);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailRecurringDepositProductList}/${params.key}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setRedeDetail({
          ...objDetail,
          active: objDetail?.status?.toLowerCase() === "active" ? true : false,
        });

        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  // FLOAT METHODS
  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = "Account Closure";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.DeleteEndOfCircle}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteEndOfCircleMsg);
            navigate("/prd0400");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      },
    );
  };

  const handleActivate = () => {
    let action = "Activate  ";
    let label = "Recurring Deposit Product";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.ViewFixedDeposit}/${state.key}?command=activate`;

        const body = {
          method: "PUT",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, "Recurring Deposit Product was activated");

            getDetailById(state);
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      },
    );
  };
  const handleDeactivate = () => {
    let action = "Deactivate  ";
    let label = "Recurring Deposit Product";

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.ViewFixedDeposit}/${state.key}?command=deactivate`;

        const body = {
          method: "PUT",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, "Recurring Deposit Product was deactivated");
            getDetailById(state);
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      },
    );
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    details: <DetailsForm redeDetail={redeDetail} />,
    currency: <CurrencyForm redeDetail={redeDetail} />,
    terms: <TermsForm redeDetail={redeDetail} />,
    settings: <SettingsForm redeDetail={redeDetail} />,
    interestRateChart: <InterestChartRateForm redeDetail={redeDetail} />,
    charges: <ChargesForm redeDetail={redeDetail} />,
    accounting: <AccountingForm redeDetail={redeDetail} />,
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onDelete={handleOnDelete}
      onApprove={handleActivate}
      onReject={handleDeactivate}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={appLabel.ViewRecurringDepositProduct}
        pageItems={appStatic.viewRecurringDepositProductItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Card
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginBottom: 50,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPRD0400);
